import React from "react";
import { Phone, Mail } from "lucide-react";

/**
 * Persistent bottom bar with click-to-call + click-to-email.
 * - Visible on every public page (hidden on /admin* via Layout condition)
 * - Full-width on mobile, floating pill-right on md+
 */
export default function StickyContactBar() {
  return (
    <div
      data-testid="sticky-contact-bar"
      className="fixed inset-x-0 bottom-0 z-40 pointer-events-none"
    >
      <div className="mx-auto max-w-[1440px] px-3 md:px-6 pb-3 md:pb-5 flex md:justify-end">
        <div
          className="pointer-events-auto w-full md:w-auto grid grid-cols-2 md:flex items-stretch md:items-center gap-px md:gap-0 bg-ink text-bg shadow-[0_12px_40px_-12px_rgba(10,46,37,0.55)] overflow-hidden rounded-sm md:rounded-full border border-accent/30"
        >
          <a
            href="tel:+18073558600"
            data-testid="sticky-contact-call"
            className="group inline-flex items-center justify-center md:justify-start gap-2 md:gap-2.5 px-5 py-3.5 md:py-3 md:pl-5 md:pr-6 text-xs md:text-sm uppercase tracking-[0.14em] hover:bg-accent hover:text-ink transition-colors"
            aria-label="Call Xtreme Care at 807-355-8600"
          >
            <Phone className="w-4 h-4 shrink-0" strokeWidth={2} />
            <span className="font-medium">807-355-8600</span>
          </a>
          <span className="hidden md:block w-px bg-bg/15" aria-hidden="true" />
          <a
            href="mailto:admin@xtremecare.ca"
            data-testid="sticky-contact-email"
            className="group inline-flex items-center justify-center md:justify-start gap-2 md:gap-2.5 px-5 py-3.5 md:py-3 md:pl-5 md:pr-6 text-xs md:text-sm uppercase tracking-[0.14em] hover:bg-accent hover:text-ink transition-colors"
            aria-label="Email admin@xtremecare.ca"
          >
            <Mail className="w-4 h-4 shrink-0" strokeWidth={2} />
            <span className="font-medium normal-case tracking-normal">
              admin@xtremecare.ca
            </span>
          </a>
        </div>
      </div>
    </div>
  );
}
